import { axiosRequest } from './../../service/axios';

export const getList = (params) => {
  const url = 'clients/list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    params,
    options,
  };
  return axiosRequest(axiosData);
};

export const clientLock = (id) => {
  const url = `clients/lock/${id}`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const clientActivate = (id) => {
  const url = `clients/activate/${id}`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const getSingleClient = (id) => {
  const url = `clients/show/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getAddFormData = () => {
  const url = 'clients/create-form-data';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getEditClient = (id) => {
  const url = `clients/edit-form-data/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const editClient = (id, data) => {
  const url = `clients/update/${id}`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const addNewClient = (data) => {
  const url = 'clients/store';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const getClientFilterList = (params) => {
  const url = 'clients/filter-list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
    params,
  };
  return axiosRequest(axiosData);
};
